import TranslationInput from './TranslationInput';
import IconButton from '../IconButton/IconButton';
import Button from '../Button/Button';
import { emptyTranslation } from '../../utils/translationUtils';
import './BulletListEditor.css';

const BulletListEditor = ({ type, bullets, onChange }) => {
  const addBullet = () => {
    if (type === 'string') {
      onChange([...bullets, emptyTranslation()]);
    } else {
      onChange([...bullets, { key: emptyTranslation(), value: emptyTranslation() }]);
    }
  };

  const removeBullet = (idx) => {
    onChange(bullets.filter((_, i) => i !== idx));
  };

  const handleBulletChange = (idx, field, lang, value) => {
    const updated = bullets.map((b, i) => {
      if (i !== idx) return b;
      if (type === 'string') {
        return { ...b, [lang]: value };
      } else {
        return { ...b, [field]: { ...b[field], [lang]: value } };
      }
    });
    onChange(updated);
  };

  return (
    <div className="bullet-list-editor">
      {bullets.map((b, idx) => (
        <div
          className="bullet-row"
          key={idx}
        >
          {type === 'string' ? (
            <TranslationInput
              label={`Bullet ${idx + 1}`}
              value={b}
              onChange={(lang, val) => handleBulletChange(idx, null, lang, val)}
            />
          ) : (
            <div className="keyvalue-row">
              <TranslationInput
                label={`Key ${idx + 1}`}
                value={b.key}
                onChange={(lang, val) => handleBulletChange(idx, 'key', lang, val)}
              />
              <TranslationInput
                label={`Value ${idx + 1}`}
                value={b.value}
                onChange={(lang, val) => handleBulletChange(idx, 'value', lang, val)}
              />
            </div>
          )}
          <IconButton
            icon="delete"
            variant="danger"
            className="bullet-remove-btn"
            onClick={() => removeBullet(idx)}
            disabled={bullets.length === 1}
            aria-label="Remove bullet"
          />
        </div>
      ))}
      <Button variant="secondary" fullWidth size="sm" onClick={addBullet}>
        <span className="material-symbols-outlined">add</span>
        Add Bullet
      </Button>
    </div>
  );
};

export default BulletListEditor;
